import { Component, computed, effect, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CallOutViewComponent } from '../call-out-view/call-out-view.component';
import { CalloutPageType, CalloutUserRoles } from '../../interfaces';
import { AuthService } from 'src/app/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-call-out-main',
  standalone: true,
  imports: [CommonModule, CallOutViewComponent],
  templateUrl: './call-out-main.component.html',
  styleUrls: ['./call-out-main.component.scss']
})
export class CallOutMainComponent {
  private authService = inject(AuthService);

  authState = signal<any>(null);
  activeTab = signal<CalloutPageType>('cs');

  userRole = signal<CalloutUserRoles>('none');

  setTab(tab: CalloutPageType) {
    this.activeTab.set(tab);
  }

  constructor() {
    effect(() => {
      const state = this.authState();

      if (!state || !state.permissions) {
        this.userRole.set('none')
      }

      const callOutPermission = state.permissions.find((perm: any) => perm.resourcePath === 'call-out');
      if (!callOutPermission) {
        this.userRole.set('none')
      }

      if (callOutPermission.context.includes('cs')) {
        this.userRole.set('cs');
        this.setTab('cs')
      } else if (callOutPermission.context.includes('planning')) {
        this.userRole.set('planning');
        this.setTab('planning')
      } else if (callOutPermission.context.includes('full')) {
        this.userRole.set('full');
        this.setTab('cs')
      } else {
        this.userRole.set('none');
      }
    }, { allowSignalWrites: true })
  }

  ngOnInit() {
    this.authService.getAuthState().subscribe(state => {
      this.authState.set(state);
    });
  }
}
